import { render, staticRenderFns } from "./AIValidation.vue?vue&type=template&id=2f6556a6"
import script from "./AIValidation.vue?vue&type=script&lang=js"
export * from "./AIValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f6556a6')) {
      api.createRecord('2f6556a6', component.options)
    } else {
      api.reload('2f6556a6', component.options)
    }
    module.hot.accept("./AIValidation.vue?vue&type=template&id=2f6556a6", function () {
      api.rerender('2f6556a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/reinbursement/AIValidation.vue"
export default component.exports